import React from 'react';

const Features = () => (
  <section
    id="about"
    className="relative w-full overflow-hidden"
    style={{ aspectRatio: '1024 / 365' }}
    aria-label="Why Choose Kyle Drive"
  >
    <img
      src="/design-master/KYLE-DRIVE-APPROVED-DESIGN.png"
      alt="Why Choose Kyle Drive"
      className="absolute left-0 w-full max-w-none"
      style={{
        top: '-115.07%',
        height: 'auto'
      }}
    />
  </section>
);

export default Features;
